import { createContext } from "react";
import type { PageParent } from "./page-parent";

export type PageTitleContextValue = {
  /** The title a page passes to its layout; read by `PageTitle` so the string is written once per page. */
  title?: string;
  /** The parent trail a page passes to its layout, nearest parent last; read by `PageParentLink`. */
  parents: PageParent[];
};

export const PageTitleContext = createContext<PageTitleContextValue>({ parents: [] });
